class FaqController {
  /* @ngInject */
  constructor() {
    this.name = 'faq';
  }
}

export default FaqController;



/** WEBPACK FOOTER **
 ** ./client/app/components/faq/faq.controller.js
 **/